<div class="mainContent" style="height: 100%; overflow: hidden;">
  <header style="padding-left: 2%;">
    <label i18n="@@spmsUserReg" class="textColour">Export Datasets</label>
  </header>

  <main style="flex: 1; overflow: hidden; padding: 2%;">
    <form #exportForm="ngForm" novalidate (ngSubmit)="confirm()" style="width: 100%;">

      <div class="row" style="margin-top: 10px;">
        <div class="col-lg-12">
          <label style="cursor: default;">Select Object Groups</label>
          <mat-form-field appearance="outline" style="width: 100%;" required>
            <mat-label>Select Object Groups</mat-label>
               <mat-select (selectionChange)="onObjectGroupChange($event.value)" [(ngModel)]="selectedOptions" name="options" multiple required>
        <mat-option *ngFor="let objectGroup of objectGroupNames" [value]="objectGroup.objectGroupId">
          {{ objectGroup.objectGroupName }}
        </mat-option>
      </mat-select>
            <mat-error *ngIf="exportForm.controls.objectGroup?.invalid && exportForm.controls.objectGroup?.touched">
              You must select at least one object group.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="row" style="margin-top: 20px;">
        <div class="col-lg-12">
          <label style="cursor: default;">Select Datasets</label>
          <mat-form-field appearance="outline" style="width: 100%;" required>
            <mat-label>Select Datasets</mat-label>
               <mat-select [(ngModel)]="selectedDatasets" name="datasets" multiple required>
        <mat-option *ngIf="filteredDatasets.length === 0" disabled>No Datasets Available</mat-option>
        <mat-option *ngFor="let dataset of filteredDatasets" [value]="dataset.reportcreationid">
          {{ dataset.datasetname }}
        </mat-option>
      </mat-select>
            <mat-error *ngIf="exportForm.controls.datasets?.invalid && exportForm.controls.datasets?.touched">
              You must select at least one dataset.
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div style="margin-top: 20px; text-align: end;">
        <button type="submit" [disabled]="exportForm.invalid"
                class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                [style.background-color]="backgroundColorButton" 
                style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px; color: white;">
          Export
        </button>

        <button type="button" (click)="onNoClick()"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" 
                [style.background-color]="backgroundColorButton" 
                style="padding: .3rem 1.6rem; font-size: .85rem; width: 95px;">
          Cancel
        </button>
      </div>
    </form>
  </main>
</div>
